import { Component } from 'react'

import ActionSet from './ActionSet'
import withSpacing from './WithSpacing'

interface InlineActionSetProps {
  actionHandler(...args: unknown[]): unknown
  inlineActions: {
    type: 'Action.OpenUrl'
    body?: string
    headers?: object
    color?: string
    data?: object
    method?: 'POST' | 'PUT' | 'DELETE' | 'GET'
    url?: string
    title: string
    card?: {
      items?: unknown[]
    }
  }[]
  theme: object
}

class InlineActionSet extends Component<InlineActionSetProps> {
  static displayName = 'InlineActionSet'

  render() {
    const { inlineActions } = this.props

    // @ts-expect-error
    return <ActionSet {...this.props} format={'outline'} actions={inlineActions} />
  }
}

const InlineActionSetWithSpacing = withSpacing(InlineActionSet)

export default InlineActionSetWithSpacing
